import styles from './Skeleton.module.css'

export default function Skeleton({ children }: { children: React.ReactElement }) {
  return <span className={styles.skeleton}>{children}</span>
}
